module.exports = __webpack_public_path__ + "static/worldcancer-bd23382497300a1dba0f6481d1f1f2a8.png";